import axios from "axios";

export default function getCompanyGroups({ page, length, search }) {
  return new Promise((resolve, reject) => axios
    .get(`/account/system-admin/api/v1/company-groups`, {
      page,
      length,
      search,
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
